export function renderCol(_renderContext, _node) {
  // const { context } = renderContext
  // const children = renderContext.api
  //     .getNodes()
  //     .filter((n) => n.parentId === node.id)
  //     .sort(sortByIndex)
  // context.save()
  // context.translate(node.x, node.y)
  // children.forEach((child, index) => {
  //     renderNode(renderContext, child)
  // })
  // context.restore()
}

export function renderRow(_renderContext, _node) {
  // const { context } = renderContext
  // const children = renderContext.api
  //     .getNodes()
  //     .filter((n) => n.parentId === node.id)
  //     .sort(sortByIndex)
  // context.save()
  // context.translate(node.x, node.y)
  // children.forEach((child, index) => {
  //     renderNode(renderContext, child)
  // })
  // context.restore()
}
